import { HubConnectionBuilder } from "@microsoft/signalr";
import AuthAPI from "./auth.js";
const Auth = new AuthAPI();

// Public
export async function buildHubAsync(route, hubConfig, resourcePath) {
	const data = await Auth.signalRAsync(route);
	if (resourcePath) {
		data.url.pathname = data.url.pathname.concat(`/${resourcePath}`);
	} else {
		data.url.pathname = data.url.pathname.concat(`/${-1}`);
	}

	let connectionBuilder = new HubConnectionBuilder()
		.withUrl(data.url.toString(), {accessTokenFactory: () => data.token })
		.withAutomaticReconnect();

	if (hubConfig.debugLog) {
		connectionBuilder = connectionBuilder.configureLogging(hubConfig.logLevel);
	}

	const connection = connectionBuilder.build();

	if (hubConfig.onReconnecting) {
		connection.onreconnecting(hubConfig.onReconnecting);
	}
	if (hubConfig.onReconnected) {
		connection.onreconnected(hubConfig.onReconnected);
	}
	if (hubConfig.onClose) {
		connection.onclose(hubConfig.onClose);
	}

	//This is specifially meant to handle the scenario where the app pool is recycled or shutdown.  This will not trigger the automatic reconnect.
	//The page where the hub is connected will have to restart the hub and any other timers and such
	if (hubConfig.onCloseError) {
		connection.onclose((error) => {
			if (error) {
				hubConfig.onCloseError();
			}
		});
	}

	return connection;
}
